export const PWD_RGX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!"'`\-\/<=>(){|}\[\]_~#%*?&.,+;:^])[A-Za-z\d@$!"'`\-/<=>(){|}\[\]_~#%*?&.,+;:^]{8,}$/

export const ERROR_MESSAGES = {
  notEqualsPwd: 'Пароли не совпадают',
  notMatchPwd:
    'Пароль должен содержать не менее 8 символов, включать латинские буквы верхнего и нижнего регистра, цифры и спецсимволы',
}



// WEBPACK FOOTER //
// ./src/templates/pages/lk/profile/security/const.js